import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';
import { PublicServiceService } from 'src/app/public-service.service';
import { getImgeUrl } from 'src/environments/environment';

@Component({
  selector: 'app-article-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './article-details.component.html',
  styleUrl: './article-details.component.scss'
})
export class ArticleDetailsComponent {
  isToggled = false;
  id
  article
  imageURL = getImgeUrl()
  constructor(
    public themeService: ThemeCustomizerService, 
    private activeRouter: ActivatedRoute, 
    private publicService: PublicServiceService, 
  ) {
      this.themeService.isToggled$.subscribe(isToggled => {
          this.isToggled = isToggled;
      });
  }

  toggleTheme() {
      this.themeService.toggleTheme();
  }

  ngOnInit(): void {
    this.id = this.activeRouter.snapshot.params["id"]
    this.getDat()
  }

  getDat() {
    this.publicService.getRecordById(this.publicService.ARTICLE_URL, this.id).subscribe({
      next: (res) => {
        this.article = res
      },
      error: (err) => {
        console.log(err)
      }
    })
  }

}
